import React from 'react';
import { XIcon } from 'lucide-react';
interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const HowItWorksModal = ({
  isOpen,
  onClose
}: HowItWorksModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-449">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-auto" data-id="element-450">
        <div className="p-6" data-id="element-451">
          <div className="flex justify-between items-center mb-4" data-id="element-452">
            <h2 className="text-2xl font-bold" data-id="element-453">How LaVee Works</h2>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100" data-id="element-454">
              <XIcon size={24} data-id="element-455" />
            </button>
          </div>
          <div className="aspect-video bg-gray-100 mb-4 rounded-lg flex items-center justify-center" data-id="element-456">
            <div className="text-center p-4" data-id="element-457">
              <p className="text-gray-500 mb-2" data-id="element-458">
                Video demonstration would appear here
              </p>
              <p className="text-sm text-gray-400" data-id="element-459">
                This will showcase how LaVee helps you discover and enjoy sports
                events
              </p>
            </div>
          </div>
          <div className="space-y-4 mb-6" data-id="element-460">
            <div data-id="element-461">
              <h3 className="font-bold text-lg" data-id="element-462">
                1. Personalize Your Experience
              </h3>
              <p data-id="element-463">Tell us which sports you love and where you're located.</p>
            </div>
            <div data-id="element-464">
              <h3 className="font-bold text-lg" data-id="element-465">2. Discover Events</h3>
              <p data-id="element-466">
                We'll show you upcoming games, events, and activities tailored
                to your interests.
              </p>
            </div>
            <div data-id="element-467">
              <h3 className="font-bold text-lg" data-id="element-468">3. Stay Connected</h3>
              <p data-id="element-469">
                Get updates, reminders, and exclusive offers for your favorite
                sports.
              </p>
            </div>
          </div>
          <button onClick={onClose} className="w-full bg-gradient-to-r from-sky-500 to-blue-600 text-white py-3 rounded-lg font-medium hover:from-sky-600 hover:to-blue-700 transition-colors" data-id="element-470">
            Got it!
          </button>
        </div>
      </div>
    </div>;
};